import Permissions from '@security/permissions';
import PermissionChecker from '@modules/iam/permission-checker';

export class AcademyPermissions {
  constructor(currentUser) {
    const permissionChecker = new PermissionChecker(
      currentUser,
    );

    this.read = permissionChecker.match(
      Permissions.values.academyRead,
    );
    this.import = permissionChecker.match(
      Permissions.values.academyImport,
    );
    this.academyAutocomplete = permissionChecker.match(
      Permissions.values.academyAutocomplete,
    );
    this.create = permissionChecker.match(
      Permissions.values.academyCreate,
    );
    this.edit = permissionChecker.match(
      Permissions.values.academyEdit,
    );
    this.destroy = permissionChecker.match(
      Permissions.values.academyDestroy,
    );
  }
}
